import { amber, brown, pink } from "@mui/material/colors";
import { createTheme, rgbToHex } from "@mui/material/styles";
import { size } from "viem";

const globalTheme = createTheme({
  palette: {
    background: {
      default: "#150a04",
    },
    primary: {
      main: brown[500],
    },
    secondary: {
      main: amber[500],
    },
    mode: "dark",
  },
  typography: {
    allVariants: {
      color: brown[400],
      fontFamily: "Roboto",
      fontSize: 14,
    },
  },
  components: {
    MuiTab: {
      defaultProps: {
        sx: {
          backgroundColor: "#150a04",
          color: brown[100],
        },
      },
    },
    MuiTable: {
      defaultProps: {
        sx: {
          backgroundColor: brown[100],
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        sx: {
          backgroundColor: brown[200],
        },
      },
    },
    MuiInput: {
      defaultProps: {
        sx: {
          backgroundColor: brown[200],
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontFamily: "Roboto",
          color: pink[600],
        },
      },
    },
    MuiList: {
      defaultProps: {
        sx: {
          fontSize: 12,
        },
      },
    },
    // MuiSelect: {
    //   defaultProps: {
    //     sx: {
    //       backgroundColor: brown[200],
    //     },
    //   },
    // },
    // MuiCollapse: {
    //   defaultProps: {
    //     sx: {
    //       backgroundColor: brown[100],
    //     },
    //   },
    // },
  },
});

export default globalTheme;
